/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../environments/environment';
import {ClientUser, RestResponse} from '../model';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {ApiHeaders} from './headers';

@Injectable()
export class ClientUserProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {}

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getClientUsers(page ? page : 1, id ? id : null, query, nonBank, lsp);
  }

  getClientUsers(page: number, id: string, query?: string, nonBank?: boolean, lsp?: boolean): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/client/${id}/user/list?page=${page}${query ? '&query=' + encodeURIComponent(query) : ''}${nonBank ? '&nonBank=' + nonBank : ''}${lsp ? '&lsp=' + lsp : ''}`,
        ApiHeaders.getOptions());
  }

  saveClientUser(clientId: string, user: ClientUser): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/client/${clientId}/user`, user, ApiHeaders.getOptions());
  }


  createClientUser(clientId: string, user: ClientUser): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/client/client-user`, {
        CLIENT_ID: clientId,
        CLIENT_USER: user
      }, ApiHeaders.getOptions());
  }

  getClientUser(clientId: string, userId: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/client/${clientId}/user/${userId}`, ApiHeaders.getOptions());
  }

  deleteClientUser(clientId: string, user: ClientUser): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/client/${clientId}/user/${user.ID}/delete`, null, ApiHeaders.getOptions());
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/client/${id}/user/field`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'CLIENT_USER';
  }
}
